export default __webpack_public_path__ + "static/media/PRESTIGIO_MARQUINIA-LUCIDO_120X278_05_265.99208675.jpg";